import { createSlice } from '@reduxjs/toolkit';

const fullScreenLoaderSlice = createSlice({
	name: 'fullScreenLoader',
	initialState: {
		isFullScreenLoading: false,  // Initially false
	},
	reducers: {
		setFullScreenLoading: (state, action) => {
			state.isFullScreenLoading = action.payload;
		},
	},
});

export const { setFullScreenLoading } = fullScreenLoaderSlice.actions;
export default fullScreenLoaderSlice.reducer;
